<template>
    <input type="text" :value="value" @input="onInput" :class="styleClass" :id ="active ? Style : 'login_input'" :placeholder="textpl" >
</template>

<script>
  export default {
    props: ['pattern', 'textpl','value','valid', 'active', 'styleClass'],
    data() {
      return {
        activated: this.value != ''
      };
    },
    computed: {
      Style() {
        if(this.valid)
        {
          return this.pattern.test(this.value) ? 'succes' : 'error';
        }
        else
        {
          return ''
        }
      }

    },
    methods: {
      onInput(e) {
        this.activated = true;
        this.$emit('input', { activate: this.activated, completed: this.pattern.test(e.target.value), value: e.target.value });
      }
    }
  };
</script>

<style scoped>
#error
{
    border: solid 1px #ff9292 !important;
}

#succes
{
    border: solid 1px @colors[green] !important;
}
</style>
